import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    header: {
        background: theme.palette.background.paper,
    },
}));
